(() => {
  const elementName = 'm-creator-videos';

  if (customElements.get(elementName)) return;

  class CreatorVideos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-creator-videos-track]');
      this.previousButton = this.querySelector('[data-creator-videos-prev]');
      this.nextButton = this.querySelector('[data-creator-videos-next]');
      this.controls = this.querySelector('[data-creator-videos-controls]');

      if (!this.track) return;

      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => this.updateControls();

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
      } else {
        this.handleResize = () => this.updateControls();
        window.addEventListener('resize', this.handleResize);
      }

      requestAnimationFrame(() => this.updateControls());
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
    }

    scrollByCard(direction) {
      if (!this.track) return;

      const card = this.track.querySelector('[data-creator-video-card]');
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;

      this.track.scrollBy({
        left: direction * step,
        behavior: 'smooth',
      });
    }

    updateControls() {
      if (!this.track) return;

      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const canScroll = maxScroll > 1;

      if (this.controls) this.controls.hidden = !canScroll;
      if (this.previousButton) this.previousButton.disabled = !canScroll || this.track.scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = !canScroll || this.track.scrollLeft >= maxScroll - 1;
    }
  }

  customElements.define(elementName, CreatorVideos);
})();
